import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import Service from "../../services/PropinsiService";
import {message} from "antd";

export const initialState = {
    loading: false,
    data: [],
    dataByID:[],
    showMessage:false,
    message:''
}


export const getDataPropinsi = createAsyncThunk('ref/propinsi',async (data, { rejectWithValue }) => {
    try {
        const response = await Service.getDataAll(data)
        //console.log(JSON.stringify(response))
        return response.data;
    } catch (err) {
        //message.error(err.response?.data?.message || 'Error',3)
    }
})

export const getDataPropinsiByID = createAsyncThunk('ref/propinsibyid',async (data, { rejectWithValue }) => {
    const {token,id,id_jadwal}=data;
    try {
        const response = await Service.getDataByID(token,id,id_jadwal)
        //console.log(JSON.stringify(response))
        return response.data;
    } catch (err) {
        //message.error(err.response?.data?.message || 'Error',3)
    }
})


export const propinsiSlice = createSlice({
    name: 'propinsi',
    initialState,
    reducers: {
        showDataSuccess: (state, action) => {
            state.loading = false
            state.data = action.payload
        },
        showLoading: (state) => {
            state.loading = true
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getDataPropinsi.fulfilled, (state, action) => {
                state.loading = false
                state.data = action.payload
            })
            .addCase(getDataPropinsi.pending, (state) => {
                state.loading = true
            })
            .addCase(getDataPropinsi.rejected, (state, action) => {
                state.message = action.payload
                state.showMessage = true
                state.loading = false
                state.data = action.payload
            })
            .addCase(getDataPropinsiByID.fulfilled, (state, action) => {
                state.loading = false
                state.dataByID = action.payload
            })
            .addCase(getDataPropinsiByID.pending, (state) => {
                state.loading = true
            })
            .addCase(getDataPropinsiByID.rejected, (state, action) => {
                state.message = action.payload
                state.showMessage = true
                state.loading = false
                state.dataByID = action.payload
            })
    },
})

export const {
    showDataSuccess,
    showLoading
} = propinsiSlice.actions

export default propinsiSlice.reducer
